import { epodApprovalStatus } from 'pando-constants';

class Order {
  static getObjectValue(array, key, Id) {
    return array.find(item => item[key] === Id);
  }

  static grnEditabilityCheckBasedOnApprovalStatus(order, canEditGrn) {
    let result = canEditGrn;
    const approvalStatus = order.epod_approval_status;
    if (approvalStatus !== epodApprovalStatus.PENDING) {
      result = order.epod_editability_based_on_approval_flow;
    }
    return result;
  }

  static hasZeroSDC(materials) {
    if (!materials || !materials.length) return false;
    return materials.every(m =>
      !m.epod.shortage_count && !m.epod.damage_count &&
      !m.epod.carton_damage_count && !m.epod.leakage_count,
    );
  }
}

export default Order;
